import { render, staticRenderFns } from "./ChangeSchedule.vue?vue&type=template&id=5d964968&scoped=true"
import script from "./ChangeSchedule.vue?vue&type=script&lang=js"
export * from "./ChangeSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d964968",
  null
  
)

export default component.exports